// import { BehaviorSubject } from 'rxjs/BehaviorSubject';
export class BaseTelemetryService {
  public name: string;
  public init(): Promise<any> {
    return Promise.resolve();
  }
  public sendEvent(event: string, metaData?: any): void {
    return;
  }
  public destroy(): void {
    return;
  }
}

export class Telemetry {
  private instantiated: boolean = false;
  private events: Array<any> = [];
  private eventId: string = '';
  private registeredServices: Array<any> = [];
  private ignoredServices: Array<string> = ['intercom'];

  public registerService = (service: BaseTelemetryService) => {
    this.registeredServices.push(service);
  };

  public registerServices = (services: Array<BaseTelemetryService>) => {
    services.forEach(this.registerService);
  };

  public initServices() {
    Promise.all(
      this.registeredServices.map(service => {
        return service.init();
      })
    ).then(services => {
      if (this.events.length > 0) {
        this.events.forEach(event => {
          this._sendEvent(event);
        });
      }
      this.instantiated = true;
    });
  }

  public setEvent(eventId: string) {
    this.eventId = eventId;
    console.log(this.eventId);
  }

  public sendEvent = (event: any) => {
    event.timestamp = new Date().toString();
    this.events.push(event);
    if (this.instantiated) {
      this._sendEvent(event);
    }
  };

  private _sendEvent = (event: any) => {
    this.registeredServices.forEach(service => {
      if (!this.ignoredServices.includes(service.name)) {
        service.sendEvent(event);
      }
    });
  };
}

export const telemetry = new Telemetry();
